const CategoryNav = Object.freeze({
    FAVOURITE_CAT_ID: -1,
});

module.exports = CategoryNav;
